import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {Api} from "../api.service";
import {Observable} from "rxjs/Observable";
import {Role} from "../api/roles/api.models";

@Injectable()
export class RolesResolver implements Resolve<any> {
    constructor(private api: Api) {}

    resolve(route: ActivatedRouteSnapshot): Observable<Role[]> {
        return Observable.create((mainObservable) => {
            return this.api.roles().collection().toPromise().then(
                (result: any) => {
                    mainObservable.next(result);
                    mainObservable.complete();
                },
                (error: any) => {
                    mainObservable.error({message: error, ngNavigationCancelingError: true});
                }
            );
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/resolvers/roles.resolver.ts